<template>
  <div class="flex-column">
    <div class="mb-2">
      <ib-button-basic color="blue" :to="{name: 'payment'}" filled>
        {{ subscriptionIsFreeTrial || !isSubscribed ? $t('pages.billing.upgrade') : $t('pages.billing.updateSubscription') }}
      </ib-button-basic>
    </div>
    <template v-if="!subscriptionIsFreeTrial && isSubscribed && !isCurrentSubscriptionDeleted">
      <ib-button-basic color="gray" class="w-100" @click="dialogCancelAccountVisible = true">
        {{ $t('pages.billing.cancelSubscription') }}
      </ib-button-basic>
    </template>
    <!-- Dialog Cancel Account -->
    <dialog-cancel-account
      :visible="dialogCancelAccountVisible"
      @close="dialogCancelAccountVisible = false"
    />
    <!-- /Dialog Cancel Account -->
  </div>
</template>

<script>
import DialogCancelAccount from '@/views/Home/AccountSettings/MyProfile/Dialogs/DialogCancelAccount.vue'
import UserSubscriptionMixin from '@/mixins/permissions/userSubscription'
import { mapGetters } from 'vuex'

export default {
  name: 'CurrentSubscriptionButtons',

  components: { DialogCancelAccount },

  mixins: [UserSubscriptionMixin],

  data () {
    return {
      dialogCancelAccountVisible: false
    }
  },

  computed: {
    ...mapGetters('user', ['isSubscribed'])
  }
}
</script>
